"use client";

import { useHasScrolled } from "@/src/hooks/use-has-scrolled";
import { cn } from "@/src/lib/utils.ts";
import { SidebarTrigger } from "../ui/sidebar";
import { AppHeaderTitle } from "./app-header-title.tsx";
import { AppSearch } from "./app-search.tsx";
import { UserMenu } from "./user-menu.tsx";
import { NotificationBell } from "../watch/notification-bell";

export interface IAppHeaderProps {
  className?: string;
  showSidebarTrigger?: boolean;
  showSearch?: boolean;
}

export function AppHeader(props: IAppHeaderProps) {
  const { showSidebarTrigger, showSearch } = props;
  const hasScrolled = useHasScrolled();

  return (
    <div className="sticky top-0 z-20">
      <div
        className={cn(
          "bg-background grid items-center gap-x-2 p-4 transition-shadow duration-200",
          showSearch
            ? "grid-cols-[1fr_auto_auto] md:grid-cols-3"
            : showSidebarTrigger
            ? "grid-cols-[auto_1fr_auto]"
            : "grid-cols-[1fr_auto]",
          hasScrolled &&
            "shadow-[0_1px_0_0_var(--border),0_8px_16px_-10px_rgb(0_0_0_/_0.14)]",
          props.className
        )}
      >
        {showSearch ? (
          <>
            <div className="flex min-w-0 items-center gap-x-2">
              {showSidebarTrigger && (
                <SidebarTrigger
                  variant="outline"
                  className="size-9 shrink-0 cursor-pointer"
                />
              )}
              <AppHeaderTitle alwaysShow={!showSidebarTrigger} />
            </div>
            <div className="justify-self-end md:justify-self-center max-w-full">
              <AppSearch />
            </div>
            <div className="justify-self-end flex items-center gap-2">
              <NotificationBell />
              <UserMenu />
            </div>
          </>
        ) : (
          <>
            {showSidebarTrigger && (
              <SidebarTrigger
                variant="outline"
                className="size-9 shrink-0 cursor-pointer"
              />
            )}
            <AppHeaderTitle alwaysShow={!showSidebarTrigger} />
            <div className="justify-self-end flex items-center gap-2">
              <NotificationBell />
              <UserMenu />
            </div>
          </>
        )}
      </div>
      <div
        aria-hidden
        className={cn(
          "pointer-events-none absolute inset-x-0 top-full h-8 bg-gradient-to-b from-background to-transparent transition-opacity duration-200",
          hasScrolled ? "opacity-100" : "opacity-0"
        )}
      />
    </div>
  );
}
